module.exports = __webpack_public_path__ + "img/remanufacturer.3be90dfe.svg";